import { useEffect, useRef, useState } from 'react';
import { Icono } from './Icono';

/**
 * RV Paginación (componentes.md §12; G121): «Anterior / Siguiente», sin total ni número de página, porque la API pagina por
 * cursor y no da el total. Botones de 44 (48 en móvil, repartidos a todo el ancho), blancos con la sombra de las tablas;
 * desactivado: sin fondo ni sombra. Al pulsar, el botón se queda negro 420 ms y la flecha avanza. La lógica está en
 * `logica/paginacion.ts` (`usePaginacionCursor`).
 */
interface Props {
    hayAnterior: boolean;
    haySiguiente: boolean;
    onAnterior: () => void;
    onSiguiente: () => void;
    movil?: boolean;
}

export function Paginacion({ hayAnterior, haySiguiente, onAnterior, onSiguiente, movil = false }: Props) {
    const [golpe, setGolpe] = useState<'a' | 's' | null>(null);
    const reloj = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
    useEffect(() => () => {
        clearTimeout(reloj.current);
    }, []);
    const marca = (lado: 'a' | 's') => {
        clearTimeout(reloj.current);
        setGolpe(lado);
        reloj.current = setTimeout(() => {
            setGolpe(null);
        }, 420);
    };
    const estilo = { flex: movil ? '1 1 0' : '0 0 auto', minHeight: movil ? 48 : 44 };
    return (
        <nav aria-label="Paginación" className="rv-pag" style={{ justifyContent: movil ? 'space-between' : 'flex-end', width: movil ? '100%' : 'auto' }}>
            <button
                type="button"
                className={`rv-pag__b${golpe === 'a' ? ' rv-pag__b--golpe' : ''}`}
                disabled={!hayAnterior}
                aria-label="Página anterior"
                style={estilo}
                onClick={() => {
                    marca('a');
                    onAnterior();
                }}
            >
                <Icono nombre="arrow-left" style={{ transform: golpe === 'a' ? 'translateX(-3px)' : 'none' }} />
                <span>Anterior</span>
            </button>
            <button
                type="button"
                className={`rv-pag__b${golpe === 's' ? ' rv-pag__b--golpe' : ''}`}
                disabled={!haySiguiente}
                aria-label="Página siguiente"
                style={estilo}
                onClick={() => {
                    marca('s');
                    onSiguiente();
                }}
            >
                <span>Siguiente</span>
                <Icono nombre="arrow-right" style={{ transform: golpe === 's' ? 'translateX(3px)' : 'none' }} />
            </button>
        </nav>
    );
}
